function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M599.33 0C930.33 0 1198.66 268.33 1198.66 599.33C1198.66 930.33 930.33 1198.66 599.33 1198.66C268.33 1198.66 0 930.33 0 599.33C0 268.33 268.33 0 599.33 0V0Z",
  fill: "#4A8CFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M208.32 411.56V693.21C208.57 756.9 260.59 808.16 324.03 807.9H734.58C746.25 807.9 755.64 798.51 755.64 787.09V505.44C755.39 441.75 703.37 390.49 639.94 390.75H229.39C217.72 390.75 208.33 400.14 208.33 411.56H208.32ZM781.77 521.43L951.27 397.61C965.99 385.43 977.4 388.47 977.4 410.55V788.11C977.4 813.23 963.44 810.19 951.27 801.05L781.77 677.48V521.43V521.43Z",
  fill: "white"
});

var SvgZoom = function SvgZoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1199,
    height: 1199,
    viewBox: "0 0 1199 1199",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom.b70ecd73.svg";
export { ForwardRef as ReactComponent };